"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4709],{

/***/ 17243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TabBuyBox_TabBuyBox; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionDetail/index.js + 2 modules
var ActionDetail = __webpack_require__(92877);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/BuyBox/index.js + 3 modules
var BuyBox = __webpack_require__(65529);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TabBuyBox/TabBuyBox.js






var TabBuyBox = function TabBuyBox(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure,
    data = _ref.data,
    configProp = _ref.config;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var product = data.product;
  var label = staticProps.label,
    sidebarTitle = staticProps.sidebarTitle;
  var handleChangeOpen = function handleChangeOpen(isOpened) {
    setOpen(isOpened);
    if (isOpened) {
      publish('buybox:seemoreoffers', {
        product: product
      });
    }
  };
  return react.createElement(ActionDetail/* default */.Z, {
    label: label,
    detailTitle: sidebarTitle,
    onChangeOpen: handleChangeOpen,
    fullScreen: true
  }, react.createElement(react.Fragment, null, open && react.createElement(BuyBox/* default */.Z, {
    "static": staticProps,
    structure: structure,
    data: data,
    config: configProp
  })));
};
TabBuyBox.defaultProps = {
  config: {},
  data: {
    product: {}
  },
  "static": {
    itemsModal: {
      href: '/lojista/',
      showDialog: false,
      spa: true
    },
    label: '',
    sellerPagePath: '/lojista/',
    sellerPageSpa: false,
    sidebarTitle: '',
    title: 'Informações da loja parceira'
  },
  structure: {
    config: {},
    cookies: {}
  }
};
 false ? 0 : void 0;
TabBuyBox.dataSource = {
  product: {
    query: 'ProductQuery'
  }
};
TabBuyBox.ssr = true;
/* harmony default export */ var TabBuyBox_TabBuyBox = (TabBuyBox);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TabBuyBox/index.js


/***/ }),

/***/ 17586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TabFactsheet_TabFactsheet; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionDetail/index.js + 2 modules
var ActionDetail = __webpack_require__(92877);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ProductBundleSelector/index.js + 1 modules
var ProductBundleSelector = __webpack_require__(87757);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 8 modules
var hooks = __webpack_require__(57508);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/Factsheet/index.js + 2 modules
var Factsheet = __webpack_require__(55770);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TabFactsheet/TabFactsheet.js

var _excluded = ["label"];






var TabFactsheet = function TabFactsheet(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var _useProductInfo = (0,hooks/* useProductInfo */.MW)(data == null ? void 0 : data.product),
    factsheet = _useProductInfo.factsheet;
  var label = staticProps.label,
    props = (0,objectWithoutProperties/* default */.Z)(staticProps, _excluded);
  var factData = factsheet == null ? void 0 : factsheet.find(function (i) {
    return i.slug === 'ficha-tecnica';
  });
  return !!factData && react.createElement(ActionDetail/* default */.Z, {
    label: label,
    detailTitle: label
  }, react.createElement(ProductBundleSelector/* default */.Z, {
    layout: {
      p: 3
    },
    data: data
  }), react.createElement(Factsheet/* default */.Z, {
    data: data,
    "static": props,
    structure: structure
  }));
};
TabFactsheet.defaultProps = {
  data: {
    product: {}
  },
  "static": {
    brandPageUrl: '',
    fontSize: 0,
    label: '',
    layout: 'vertical'
  },
  structure: {}
};
 false ? 0 : void 0;
TabFactsheet.dataSource = {
  product: {
    fragments: ['includeFactSheet']
  }
};
TabFactsheet.ssr = true;
/* harmony default export */ var TabFactsheet_TabFactsheet = (TabFactsheet);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TabFactsheet/index.js


/***/ }),

/***/ 17365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TabPaymentMethods_TabPaymentMethods; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/PaymentMethods/index.js + 2 modules
var PaymentMethods = __webpack_require__(20451);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TabPaymentMethods/TabPaymentMethods.js





var TabPaymentMethods = function TabPaymentMethods(_ref) {
  var data = _ref.data;
  var _ref2 = (data == null ? void 0 : data.product) || {},
    _ref2$paymentMethods = _ref2.paymentMethods,
    paymentMethods = _ref2$paymentMethods === void 0 ? [] : _ref2$paymentMethods;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var handlePaymentMethodClick = function handlePaymentMethodClick() {
    return setVisible(true);
  };
  var handleCloseSidebar = function handleCloseSidebar() {
    return setVisible(false);
  };
  return !!paymentMethods.length && react.createElement(Sidebar/* default */.Z, {
    visible: visible,
    direction: "right",
    onClickOutside: handleCloseSidebar
  }, react.createElement(Sidebar/* default.Header */.Z.Header, {
    icon: "close",
    textAlign: "left",
    onClick: handleCloseSidebar
  }), react.createElement(PaymentMethods/* default */.Z, {
    data: data,
    onEvent: handlePaymentMethodClick
  }));
};
 false ? 0 : void 0;
TabPaymentMethods.defaultProps = {
  data: {}
};
TabPaymentMethods.ssr = true;
TabPaymentMethods.dataSource = {
  product: {
    fragments: ['showPayment'],
    query: 'ProductQuery'
  }
};
/* harmony default export */ var TabPaymentMethods_TabPaymentMethods = (TabPaymentMethods);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TabPaymentMethods/index.js


/***/ }),

/***/ 86633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TabProductDetail_TabProductDetail; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionDetail/index.js + 2 modules
var ActionDetail = __webpack_require__(92877);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 8 modules
var hooks = __webpack_require__(57508);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ProductDetail/index.js + 2 modules
var ProductDetail = __webpack_require__(9747);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TabProductDetail/TabProductDetail.js








function TabProductDetail(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"];
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useProductInfo = (0,hooks/* useProductInfo */.MW)(data == null ? void 0 : data.product),
    description = _useProductInfo.description;
  var label = staticProps.label,
    detailTitle = staticProps.detailTitle;
  var handleDetailClickEvent = function handleDetailClickEvent() {
    return setIsOpen(!isOpen);
  };
  return react.createElement(ActionDetail/* default */.Z, {
    label: label,
    content: description,
    detailTitle: detailTitle,
    open: isOpen,
    onCloseSidebar: function onCloseSidebar() {
      return setIsOpen(false);
    }
  }, react.createElement(ProductDetail/* default */.Z, {
    data: data,
    "static": (0,esm_extends/* default */.Z)({}, staticProps, {
      label: '',
      py: 2
    }),
    onClick: handleDetailClickEvent
  }));
}
TabProductDetail.defaultProps = {
  data: {},
  "static": {
    detailTitle: '',
    label: ''
  }
};
 false ? 0 : void 0;
TabProductDetail.dataSource = {
  product: {
    fragments: ['includeDescription'],
    query: 'ProductQuery'
  }
};
TabProductDetail.ssr = true;
/* harmony default export */ var TabProductDetail_TabProductDetail = ((0,withLayoutProps/* default */.Z)(TabProductDetail));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TabProductDetail/index.js


/***/ }),

/***/ 33682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TabRating_TabRating; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionDetail/index.js + 2 modules
var ActionDetail = __webpack_require__(92877);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewStats/index.js + 2 modules
var ReviewStats = __webpack_require__(4506);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ReviewResult/index.js + 1 modules
var ReviewResult = __webpack_require__(98396);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TabRating/TabRating.styles.js

var _templateObject;



var Content = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-top-width: 4px;\n  border-top-style: solid;\n  border-top-color: ", ";\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* getBackgroundColor */.dF)('darker')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TabRating/TabRating.js











var TabRating = function TabRating(_ref) {
  var staticProps = _ref["static"],
    data = _ref.data;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var label = staticProps.label,
    ratingTitle = staticProps.ratingTitle,
    createReviewUrl = staticProps.createReviewUrl,
    actionLabel = staticProps.actionLabel;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe,
    publish = _usePublisher.publish;
  var review = data.review;
  var stats = review.stats;
  var handleRatingClickEvent = function handleRatingClickEvent() {
    return setIsOpen(!isOpen);
  };
  (0,react.useEffect)(function () {
    subscribe('product:rating:click', handleRatingClickEvent);
    return function () {
      unsubscribe('product:rating:click', handleRatingClickEvent);
    };
  });
  var onReviewButtonClick = function onReviewButtonClick() {
    publish('product:review:click');
    (0,esm/* routePush */.dY)({
      path: createReviewUrl,
      spa: true
    });
  };
  var getReviewStats = function getReviewStats() {
    return react.createElement(Content, {
      pt: [2, 2, 2, 2],
      pl: [4, 4, 4, 4],
      pr: [4, 4, 4, 4]
    }, react.createElement(ReviewStats/* default */.Z, (0,esm_extends/* default */.Z)({}, stats, {
      actionLabel: actionLabel,
      distribution: stats ? (0,toConsumableArray/* default */.Z)(stats.distribution) : [],
      onReviewButtonClick: onReviewButtonClick
    })));
  };
  return react.createElement(ActionDetail/* default */.Z, {
    label: label,
    detailTitle: ratingTitle,
    open: isOpen,
    onCloseSidebar: function onCloseSidebar() {
      return setIsOpen(false);
    },
    content: getReviewStats()
  }, react.createElement(react.Fragment, null, react.createElement(ReviewResult/* default */.Z, {
    data: data,
    "static": staticProps
  })));
};
TabRating.defaultProps = {
  data: {},
  "static": {
    label: '',
    ratingTitle: '',
    reviewPageSize: 20
  },
  structure: {}
};
 false ? 0 : void 0;
TabRating.dataSource = {
  product: {
    query: 'ProductQuery'
  },
  review: {
    query: 'ReviewQuery'
  }
};
TabRating.ssr = true;
/* harmony default export */ var TabRating_TabRating = (TabRating);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TabRating/index.js


/***/ }),

/***/ 98898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TermList_TermList; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TextList/index.js + 2 modules
var TextList = __webpack_require__(35306);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TermList/TermList.js



var _excluded = ["hideListPoint", "layout", "limitListItems", "showAllItems", "terms", "termUrl", "title", "titleAs", "urlReplaceString"];






var TermList = function TermList(_ref) {
  var staticProps = _ref["static"];
  var _staticProps$hideList = staticProps.hideListPoint,
    hideListPoint = _staticProps$hideList === void 0 ? true : _staticProps$hideList,
    layout = staticProps.layout,
    limitListItems = staticProps.limitListItems,
    _staticProps$showAllI = staticProps.showAllItems,
    showAllItems = _staticProps$showAllI === void 0 ? true : _staticProps$showAllI,
    terms = staticProps.terms,
    _staticProps$termUrl = staticProps.termUrl,
    termUrl = _staticProps$termUrl === void 0 ? '/busca/{term}/' : _staticProps$termUrl,
    title = staticProps.title,
    titleAs = staticProps.titleAs,
    _staticProps$urlRepla = staticProps.urlReplaceString,
    urlReplaceString = _staticProps$urlRepla === void 0 ? '{term}' : _staticProps$urlRepla,
    props = (0,objectWithoutProperties/* default */.Z)(staticProps, _excluded);
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var list = terms.reduce(function (acc, item) {
    var term = (item == null ? void 0 : item.term) || (item == null ? void 0 : item.value) || item;
    return !term || typeof term !== 'string' ? (0,toConsumableArray/* default */.Z)(acc) : [].concat((0,toConsumableArray/* default */.Z)(acc), [[{
      href: termUrl.replace(urlReplaceString, (0,esm/* slugSearchUrl */.EB)(term)),
      value: term.replace(/,/g, '')
    }]]);
  }, []);
  var onLinkClick = function onLinkClick(e, _ref2) {
    var href = _ref2.href,
      value = _ref2.value;
    e.preventDefault();
    publish('listlink:click', {
      label: value
    });
    (0,esm/* routePush */.dY)({
      path: href,
      spa: true
    });
  };
  return list.length > 0 && react.createElement(TextList/* default */.Z, (0,esm_extends/* default */.Z)({
    handleClickLink: onLinkClick,
    hideListPoint: hideListPoint,
    limitListItems: limitListItems,
    list: list,
    showAllItems: showAllItems,
    title: title,
    titleAs: titleAs,
    typeList: "flex"
  }, props));
};
TermList.ssr = true;
 false ? 0 : void 0;
TermList.defaultProps = {
  "static": {}
};
/* harmony default export */ var TermList_TermList = ((0,withLayoutProps/* default */.Z)(TermList));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TermList/index.js


/***/ }),

/***/ 46185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TextList_TextList; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TextList/index.js + 2 modules
var organisms_TextList = __webpack_require__(35306);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TextList/TextList.js





var TextList = function TextList(_ref) {
  var staticProps = _ref["static"];
  var hideListPoint = staticProps.hideListPoint,
    layout = staticProps.layout,
    list = staticProps.list,
    title = staticProps.title,
    titleAs = staticProps.titleAs,
    typeList = staticProps.typeList;
  return react.createElement(organisms_TextList/* default */.Z, (0,esm_extends/* default */.Z)({
    hideListPoint: hideListPoint,
    list: list,
    title: title,
    titleAs: titleAs,
    typeList: typeList
  }, layout));
};
 false ? 0 : void 0;
TextList.defaultProps = {
  "static": {}
};
TextList.ssr = true;
/* harmony default export */ var TextList_TextList = ((0,withLayoutProps/* default */.Z)(TextList));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/TextList/index.js


/***/ }),

/***/ 10492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ToolBar_ToolBar; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Toolbar/index.js + 2 modules
var Toolbar = __webpack_require__(91061);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ToolBar/ToolBar.styles.js

var _templateObject;

var ToolbarContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 4px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ToolBar/ToolBar.js




var _excluded = ["buildHref"];







var ToolBar = function ToolBar(_ref) {
  var _structure$route;
  var data = _ref.data,
    _ref$static = _ref["static"],
    initialDisplay = _ref$static.initialDisplay,
    _ref$static$showFilte = _ref$static.showFilters,
    showFilters = _ref$static$showFilte === void 0 ? true : _ref$static$showFilte,
    _ref$static$showSort = _ref$static.showSort,
    showSort = _ref$static$showSort === void 0 ? true : _ref$static$showSort,
    _ref$static$customCat = _ref$static.customCategoryFilter,
    customCategoryFilter = _ref$static$customCat === void 0 ? false : _ref$static$customCat,
    _ref$static$removeFil = _ref$static.removeFilters,
    removeFilters = _ref$static$removeFil === void 0 ? [] : _ref$static$removeFil,
    _ref$static$sortLabel = _ref$static.sortLabel,
    sortLabel = _ref$static$sortLabel === void 0 ? 'Ordenar' : _ref$static$sortLabel,
    _ref$static$uniqueFil = _ref$static.uniqueFilters,
    uniqueFilters = _ref$static$uniqueFil === void 0 ? [] : _ref$static$uniqueFil,
    structure = _ref.structure;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var query = structure.query;
  var _ref2 = (data == null ? void 0 : data.search) || {},
    sorts = _ref2.sorts;
  var onChangeSort = function onChangeSort(sort) {
    var sortType = sort.type,
      sortOrientation = sort.orientation;
    publish('productlist:sort:change', {
      sort: sort
    });
    var path = (0,esm/* getCurrentPath */.Jz)({
      page: 1,
      sortOrientation: sortOrientation,
      sortType: sortType
    });
    (0,esm/* routePush */.dY)({
      path: path,
      spa: true
    });
  };
  var _ref3 = (data == null ? void 0 : data.search) || {},
    filters = _ref3.filters;
  var filteredBySidePosition = filters == null ? void 0 : filters.map(function (item) {
    if ((0,esm/* filterByDelivery */.wz)(item)) {
      var _item$values;
      var filteredValues = item == null ? void 0 : (_item$values = item.values) == null ? void 0 : _item$values.filter(function (value) {
        var _value$position;
        return value == null ? void 0 : (_value$position = value.position) == null ? void 0 : _value$position.includes('side');
      });
      return (0,esm_extends/* default */.Z)({}, item, {
        values: filteredValues
      });
    }
    return item;
  });
  var sortFilters = function sortFilters() {
    var _data$search;
    var searchFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var filterBySlug = searchFilters.reduce(function (acc, filter) {
      return (0,esm_extends/* default */.Z)({}, acc, (0,defineProperty/* default */.Z)({}, filter.slug, filter));
    }, {});
    var baseFilters = (data == null ? void 0 : (_data$search = data.search) == null ? void 0 : _data$search.filters) || [];
    return baseFilters.reduce(function (acc, _ref4) {
      var _filterBySlug$slug, _filterBySlug$slug$va, _filterBySlug$slug2;
      var slug = _ref4.slug;
      return filterBySlug[slug] && (((_filterBySlug$slug = filterBySlug[slug]) == null ? void 0 : (_filterBySlug$slug$va = _filterBySlug$slug.values) == null ? void 0 : _filterBySlug$slug$va.length) || ((_filterBySlug$slug2 = filterBySlug[slug]) == null ? void 0 : _filterBySlug$slug2.componentType) === 'priceRange') ? [].concat((0,toConsumableArray/* default */.Z)(acc), [filterBySlug[slug]]) : acc;
    }, []);
  };
  var buildFilterFilters = function buildFilterFilters() {
    var searchFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var _filtersParser = (0,esm/* filtersParser */.U8)({
        customCategoryFilter: customCategoryFilter,
        data: data,
        filters: searchFilters,
        query: query,
        removeFilters: removeFilters,
        structure: structure
      }),
      attributeFilters = _filtersParser.attributeFilters,
      reviewFilters = _filtersParser.reviewFilters,
      categoryFilters = _filtersParser.categoryFilters,
      priceFilters = _filtersParser.priceFilters;
    var newParsedFilters = attributeFilters.map(function (filter) {
      var componentType = uniqueFilters.some(function (uniqueFilterConfig) {
        return (0,esm/* hasSomeEqualProp */.dD)(filter, uniqueFilterConfig);
      }) ? 'unique' : 'multiple';
      return (0,esm_extends/* default */.Z)({}, filter, {
        componentType: componentType
      });
    });
    if (reviewFilters) {
      reviewFilters.componentType = 'unique';
      newParsedFilters.push(reviewFilters);
    }
    if (categoryFilters) {
      categoryFilters.componentType = 'hierarchical';
      newParsedFilters.push(categoryFilters);
    }
    if (priceFilters) {
      priceFilters.componentType = 'priceRange';
      newParsedFilters.push(priceFilters);
    }
    return sortFilters(newParsedFilters);
  };
  var parsedFilters = buildFilterFilters(filteredBySidePosition);
  var currentSidebarFilters = ((structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.filters) || []).filter(function (_ref5) {
    var origin = _ref5.origin;
    return origin !== 'url';
  });
  var filtersCount = (0,esm/* filterCountByType */.nS)(currentSidebarFilters);
  var onFilterClick = function onFilterClick(action) {
    if (action) {
      publish('productlist:filter:open');
    } else {
      publish('productlist:filter:close');
    }
  };
  var onFiltersClear = function onFiltersClear() {
    publish('productlist:filter:clean');
    var asPath = structure.asPath,
      rawPath = structure.rawPath;
    var path = (0,esm/* urlCleanFilters */.Zq)(asPath, rawPath, query);
    (0,esm/* routePush */.dY)({
      path: path,
      spa: true
    });
  };
  var onFilterItemClick = function onFilterItemClick() {
    var custom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return function (e, filter) {
      e.preventDefault();
      publish('productlist:filter:click', (0,esm_extends/* default */.Z)({}, filter, {
        custom: custom
      }));
      (0,esm/* routePush */.dY)({
        path: filter == null ? void 0 : filter.href,
        spa: true
      });
    };
  };
  var onFilterPriceApply = function onFilterPriceApply(e, _ref6, filter) {
    var min = _ref6.min,
      max = _ref6.max;
    e.preventDefault();
    var buildHref = filter.buildHref,
      appliedFilter = (0,objectWithoutProperties/* default */.Z)(filter, _excluded);
    var applyPriceHref = buildHref(max, min);
    publish('productlist:filter:click', (0,esm_extends/* default */.Z)({}, appliedFilter, {
      selectedMax: max,
      selectedMin: min
    }));
    (0,esm/* routePush */.dY)({
      path: applyPriceHref,
      spa: true
    });
  };
  var onFilterShowDetail = function onFilterShowDetail(filter) {
    publish('productlist:filter:showdetail', filter);
  };
  return react.createElement(ToolbarContainer, {
    "data-testid": "toolbar"
  }, react.createElement(Toolbar/* default */.Z, {
    defaultDisplayMode: initialDisplay,
    sortOptions: showSort && sorts,
    sortLabel: sortLabel,
    showSelectedOptionLabel: !!(query == null ? void 0 : query.sortType),
    onChangeSort: onChangeSort,
    filters: parsedFilters,
    showFilters: showFilters && parsedFilters,
    filtersCount: filtersCount,
    onFilterClick: onFilterClick,
    onFiltersClear: onFiltersClear,
    onFilterItemClick: {
      attributeFilter: onFilterItemClick(),
      categoryFilter: onFilterItemClick(true),
      priceFilter: onFilterPriceApply,
      reviewFilter: onFilterItemClick()
    },
    onFilterTypeClick: onFilterShowDetail
  }));
};
ToolBar.ssr = true;
ToolBar.defaultProps = {
  data: {},
  "static": {
    customCategoryFilter: false,
    initialDisplay: 'gallery',
    removeFilters: [],
    showFilters: true,
    showSort: true,
    sortLabel: 'Ordenar'
  },
  structure: {}
};
 false ? 0 : void 0;
/* harmony default export */ var ToolBar_ToolBar = ((0,withLayoutProps/* default */.Z)(ToolBar));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ToolBar/index.js


/***/ }),

/***/ 17322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ VisibilitySection_VisibilitySection; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(25491);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/VisibilitySection/VisibilitySection.js




var VisibilitySection = function VisibilitySection(_ref) {
  var children = _ref.children,
    eventKey = _ref.eventKey,
    eventValue = _ref.eventValue;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  return react.createElement((visibility_sensor_default()), {
    scrollCheck: true,
    onChange: function onChange(isVisible) {
      return publish(eventKey, {
        eventValue: eventValue,
        isVisible: isVisible
      });
    }
  }, children);
};
VisibilitySection.defaultProps = {
  eventKey: 'product:active:section',
  eventValue: ''
};
 false ? 0 : void 0;
/* harmony default export */ var VisibilitySection_VisibilitySection = (VisibilitySection);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/VisibilitySection/index.js


/***/ }),

/***/ 76331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ WishlistButton_WishlistButton; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AddWishlistButton/index.js + 2 modules
var AddWishlistButton = __webpack_require__(38825);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var build_esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/commons/index.js + 2 modules
var commons = __webpack_require__(26334);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/WishlistButton/WishlistButton.js




function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }









var WishlistButton = function WishlistButton(_ref) {
  var _structure$cookies, _structure$cookies$ac;
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _useImportTax = (0,esm.useImportTax)(),
    tax = _useImportTax.tax;
  var _ref2 = structure.cookies || {},
    _ref2$accountData = _ref2.accountData,
    _ref2$accountData2 = _ref2$accountData === void 0 ? {} : _ref2$accountData,
    _ref2$accountData2$id = _ref2$accountData2.id,
    userId = _ref2$accountData2$id === void 0 ? '' : _ref2$accountData2$id;
  var product = data.product;
  var variationId = product.variationId,
    productId = product.id;
  var _ref3 = (structure == null ? void 0 : structure.config) || {},
    domain = _ref3.domain,
    cartUrl = _ref3.cartUrl;
  var imgHeight = staticProps.imgHeight,
    imgWidth = staticProps.imgWidth;
  var _useWishlistProvider = (0,esm.useWishlistProvider)(),
    addToWishlist = _useWishlistProvider.addToWishlist,
    updateWishlist = _useWishlistProvider.updateWishlist,
    isOnWishlist = _useWishlistProvider.isOnWishlist,
    removeFromWishlist = _useWishlistProvider.removeFromWishlist;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    wishlist = _useState2[0],
    setWishlist = _useState2[1];
  (0,react.useEffect)((0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
    var _yield$updateWishlist, error;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return updateWishlist();
        case 2:
          _yield$updateWishlist = _context.sent;
          error = _yield$updateWishlist.error;
          if (!error) setWishlist(isOnWishlist(variationId));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [productId]);
  var eventData = {
    customer_id: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id,
    pageName: structure == null ? void 0 : structure.name
  };
  var handleClickWishBtn = function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee2() {
      var asPath;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!userId) {
              _context2.next = 6;
              break;
            }
            if (!isOnWishlist(product == null ? void 0 : product.variationId)) {
              publish('addToWishlist:click', (0,esm_extends/* default */.Z)({}, eventData, product, {
                tax: tax
              }));
            }
            _context2.next = 4;
            return (0,commons/* buildWishListActions */.rz)({
              addToWishlist: addToWishlist,
              isOnWishlist: isOnWishlist,
              publish: publish,
              removeFromWishlist: removeFromWishlist,
              shouldUpdateHeart: function shouldUpdateHeart() {
                return setWishlist(isOnWishlist(variationId));
              },
              structure: structure
            })({
              customerId: userId,
              isLiked: wishlist,
              product: product
            });
          case 4:
            _context2.next = 8;
            break;
          case 6:
            asPath = structure.asPath;
            (0,build_esm/* cartRedirect */._V)({
              cartUrl: cartUrl,
              next: "".concat(domain).concat(asPath),
              type: 'login'
            });
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleClickWishBtn() {
      return _ref5.apply(this, arguments);
    };
  }();
  return react.createElement(Box/* default */.Z, null, react.createElement(AddWishlistButton/* default */.Z, {
    active: wishlist,
    height: imgHeight,
    onClick: handleClickWishBtn,
    textAlign: "right",
    width: imgWidth
  }));
};
 false ? 0 : void 0;
WishlistButton.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
WishlistButton.ssr = true;
/* harmony default export */ var WishlistButton_WishlistButton = ((0,withLayoutProps/* default */.Z)(WishlistButton));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/WishlistButton/index.js


/***/ }),

/***/ 199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ZipCodeBar_ZipCodeBar; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ZipcodeBar/index.js + 2 modules
var ZipcodeBar = __webpack_require__(41323);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var graphql_build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var utils_build_esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Popper/index.js + 2 modules
var Popper = __webpack_require__(7121);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ZipCodeBar/ZipCodeBar.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;







var ClosePopper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    width: 'fit-content'
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-self: baseline;\n  justify-self: end;\n"])));
var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n\n  /* TODO: move to another global handler\n     - control show ludetail\n  */\n\n  & ~ footer {\n    display: block;\n  }\n\n  & ~ #ludetail {\n    display: block;\n  }\n"])));
var Content = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'white',
    fontSize: 1,
    lineHeight: 'display'
  }, props);
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), index_esm/* typography */.cp);
var ZipCodeBar_styles_Popper = (0,styled_components_browser_esm/* default */.ZP)(Popper/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    backgroundColor: 'background.primary',
    ml: 2,
    mr: 3
  }, props);
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: ", ";\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('zIndices.1')(props);
});
var SuccessContainer = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  grid-template-columns: repeat(3, auto);\n  gap: 2px;\n"])));
var Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'white',
    fontSize: 2,
    fontWeight: 'bold',
    lineHeight: 'display',
    mb: 2
  }, props);
})(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), index_esm/* typography */.cp);
var ZipCodeBtn = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'white',
    fontSize: 2,
    fontWeight: 'bold',
    justifySelf: 'flex-end',
    mb: 2,
    mt: 3
  }, props);
})(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ZipCodeBar/ZipCodeBar.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }











function ClosePopupBtn(_ref) {
  var onClick = _ref.onClick;
  return react.createElement(ClosePopper, {
    "data-testid": "close-btn",
    onClick: onClick
  }, react.createElement(esm/* Icon */.JO$, {
    name: "Close",
    width: 24,
    height: 24,
    color: "white",
    cursor: "pointer",
    "data-testid": "Close"
  }));
}
 false ? 0 : void 0;
var getZipcode = function getZipcode(shouldUpdateZipcode, locationZipCode, accountZipCode) {
  return shouldUpdateZipcode ? locationZipCode : accountZipCode;
};
function ZipCodeBar(_ref2) {
  var structure = _ref2.structure,
    staticProps = _ref2["static"],
    config = _ref2.config;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish,
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var parentRef = (0,react.useRef)(null);
  var _structure$cookies = structure.cookies,
    _structure$cookies2 = _structure$cookies === void 0 ? {} : _structure$cookies,
    _structure$cookies2$l = _structure$cookies2.location,
    initialLocation = _structure$cookies2$l === void 0 ? {} : _structure$cookies2$l,
    rejectZipcodePopup = _structure$cookies2.rejectZipcodePopup,
    accountData = _structure$cookies2.accountData;
  var zipCodeBar = staticProps.zipCodeBar,
    _staticProps$popper = staticProps.popper,
    popper = _staticProps$popper === void 0 ? {
      enabled: false
    } : _staticProps$popper;
  var popperEnabled = popper.enabled,
    _popper$info = popper.info,
    _popper$info2 = _popper$info === void 0 ? {} : _popper$info,
    popperTitle = _popper$info2.title,
    popperContent = _popper$info2.content,
    popperBtnLabel = _popper$info2.buttonLabel,
    _popper$success = popper.success,
    _popper$success2 = _popper$success === void 0 ? {} : _popper$success,
    popperSuccessTitle = _popper$success2.title,
    popperSuccessContent = _popper$success2.content;
  var zipCodeBarText = zipCodeBar.zipCodeBarText;
  var _useState = (0,react.useState)(initialLocation),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    location = _useState2[0],
    setLocation = _useState2[1];
  var _useLocation = (0,graphql_build_esm.useLocation)(),
    locationData = _useLocation.location,
    error = _useLocation.error,
    getData = _useLocation.getData;
  var shouldUpdateZipcode = (0,utils_build_esm/* isZipcodeInvalid */.tl)(location);
  (0,react.useEffect)((0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!((accountData == null ? void 0 : accountData.zip_code) && !initialLocation.zipCode || shouldUpdateZipcode)) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return getData({
            zipCode: getZipcode(shouldUpdateZipcode, location.zipCode, accountData.zip_code)
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), []);
  (0,react.useEffect)((0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee2() {
    var zipCode, updatedLocation;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!error && locationData.location && (!location.zipCode || shouldUpdateZipcode)) {
            zipCode = getZipcode(shouldUpdateZipcode, location.zipCode, accountData.zip_code);
            updatedLocation = {
              zipCode: zipCode,
              zipCodeCity: locationData.location.city,
              zipCodeState: locationData.location.state
            };
            (0,utils_build_esm/* setLocationCookies */.Qf)(locationData.location, zipCode, structure, config);
            setLocation(updatedLocation);
            publish('zipcode:auto', updatedLocation);
          }
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [error, JSON.stringify(locationData.location)]);
  (0,react.useEffect)(function () {
    setLocation(initialLocation);
  }, [JSON.stringify(initialLocation)]);
  var _useState3 = (0,react.useState)(!initialLocation.zipCode && !rejectZipcodePopup ? 'info' : null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    showPopper = _useState4[0],
    setShowPopper = _useState4[1];
  var handleBarClick = function handleBarClick() {
    setShowPopper(null);
    publish('zipcodebar:click');
    publish('zipcodeinput:toggle');
  };
  var handlePopperBtn = function handlePopperBtn() {
    setShowPopper(null);
    publish('zipcodebar:popup:click');
    publish('zipcodeinput:toggle');
  };
  var handleClosePopper = function handleClosePopper() {
    publish('addtorejectzipcode:success');
    publish('zipcodebar:popup:close');
    setShowPopper(null);
  };
  var handleZipcodeSuccess = function handleZipcodeSuccess() {
    publish('zipcodebar:popup:success');
    setShowPopper('success');
  };
  (0,react.useEffect)(function () {
    subscribe('zipcodebar:response:success', handleZipcodeSuccess);
    return function () {
      unsubscribe('zipcodebar:response:success', handleZipcodeSuccess);
    };
  });
  (0,react.useEffect)(function () {
    if (showPopper) {
      publish('zipcodebar:popup:view');
    }
  }, [showPopper]);
  var renderInfoPopper = function renderInfoPopper() {
    return react.createElement(Grid/* default */.Z, {
      mr: 1,
      ml: 1,
      mb: 2,
      pl: 1,
      "data-testid": "popper-info-container"
    }, react.createElement(ClosePopupBtn, {
      onClick: handleClosePopper
    }), react.createElement(Title, null, popperTitle), react.createElement(Content, null, popperContent), react.createElement(ZipCodeBtn, {
      "data-testid": "popper-btn",
      onClick: handlePopperBtn
    }, popperBtnLabel));
  };
  var renderSuccessPopper = function renderSuccessPopper() {
    return react.createElement(Flex/* default */.Z, {
      gap: 2,
      p: 2,
      alignItems: "center",
      "data-testid": "popper-success-container"
    }, react.createElement(esm/* Icon */.JO$, {
      name: "DoneCircle",
      width: 32,
      height: 32,
      color: "white",
      "data-testid": "DoneCircle"
    }), react.createElement(Box/* default */.Z, null, react.createElement(Title, null, popperSuccessTitle), react.createElement(Content, null, popperSuccessContent)), react.createElement(ClosePopupBtn, {
      onClick: function onClick() {
        return setShowPopper(null);
      }
    }));
  };
  return react.createElement(Container, {
    ref: parentRef,
    "data-testid": "zipcode-bar"
  }, react.createElement(ZipcodeBar/* default */.Z, {
    text: zipCodeBarText.text,
    defaultText: zipCodeBarText.defaultText,
    zipcode: location.zipCode,
    city: location.zipCodeCity,
    state: location.zipCodeState,
    onClick: handleBarClick
  }), popperEnabled && react.createElement(ZipCodeBar_styles_Popper, {
    visible: !!showPopper,
    parentRef: parentRef
  }, showPopper === 'success' ? renderSuccessPopper() : renderInfoPopper()));
}
ZipCodeBar.ssr = false;
ZipCodeBar.defaultProps = {
  config: {}
};
 false ? 0 : void 0;
/* harmony default export */ var ZipCodeBar_ZipCodeBar = (ZipCodeBar);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ZipCodeBar/index.js


/***/ }),

/***/ 40261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ZipCodeInput_ZipCodeInput; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@opentelemetry/api/build/esm/trace-api.js + 21 modules
var trace_api = __webpack_require__(94843);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ZipcodeInput/index.js + 2 modules
var ZipcodeInput = __webpack_require__(41237);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var graphql_build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var utils_build_esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ZipCodeInput/ZipCodeInput.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;









var BackgroundImg = (0,styled_components_browser_esm/* default */.ZP)(ResponsiveImage/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 80px;\n  background-color: ", ";\n\n  ", " {\n    width: 200px;\n  }\n"])), function (props) {
  return props.bgColor;
}, (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'));
var CloseComponent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  justify-content: flex-end;\n"])));
var DialogStyled = (0,styled_components_browser_esm/* default */.ZP)(Dialog/* default */.Z)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 690px;\n  padding: 0px;\n"])));
var GridContainer = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " {\n    grid-template-columns: 1fr 2fr;\n    grid-template-rows: 1fr;\n  }\n"])), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'));
var ImageContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function () {
  return {
    alignItems: 'center',
    bg: 'background.primary',
    justifyContent: 'center',
    py: 2
  };
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " {\n    height: 360px;\n    width: 280px;\n  }\n"])), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'));
var InputContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(function () {
  return {
    bg: 'background.base',
    padding: 2
  };
})(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " {\n    padding: ", "px;\n  }\n"])), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('space.4'));
var Subtitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    fontSize: 2,
    py: 3
  }, props);
})(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: ", ";\n\n  ", "\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('lineHeights.display')(props);
}, index_esm/* typography */.cp);
var Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    py: 3
  }, props);
})(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "px;\n  font-weight: ", ";\n\n  color: ", ";\n\n  ", " {\n    font-size: ", "px;\n    font-weight: ", ";\n  }\n\n  ", "\n"])), (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.3'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontWeights.medium'), function (props) {
  return (0,stereo_ui_styles_build_esm/* getPaletteColor */.ow)('greyishBrown')(props);
}, (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.5'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontWeights.bold'), index_esm/* typography */.cp);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ZipCodeInput/ZipCodeInput.js




function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }









function ZipCodeInput(_ref) {
  var structure = _ref.structure,
    staticProps = _ref["static"],
    modalOpen = _ref.open,
    config = _ref.config;
  var span = trace_api/* trace.getActiveSpan */.g.getActiveSpan();
  var _useState = (0,react.useState)(modalOpen),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0,react.useState)(),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    zipCode = _useState4[0],
    zipCodeSet = _useState4[1];
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish,
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _useLocation = (0,graphql_build_esm.useLocation)(),
    locationData = _useLocation.location,
    loading = _useLocation.loading,
    error = _useLocation.error,
    getData = _useLocation.getData;
  var _structure$cookies = structure.cookies,
    _structure$cookies2 = _structure$cookies === void 0 ? {} : _structure$cookies,
    location = _structure$cookies2.location;
  var dialogType = staticProps.dialogType,
    inputButtonText = staticProps.inputButtonText,
    position = staticProps.position,
    showButton = staticProps.showButton,
    showClose = staticProps.showClose,
    subTitleText = staticProps.subTitleText,
    titleStyle = staticProps.titleStyle,
    titleText = staticProps.titleText,
    image = staticProps.image;
  var zipcode = location.zipCode;
  var refresh = function refresh() {
    return (0,utils_build_esm/* routePush */.dY)({
      refresh: true
    });
  };
  var handleZipcodeClickEvent = function handleZipcodeClickEvent() {
    return setOpen(!open);
  };
  (0,react.useEffect)(function () {
    subscribe('zipcodeinput:toggle', handleZipcodeClickEvent);
    return function () {
      unsubscribe('zipcodeinput:toggle', handleZipcodeClickEvent);
    };
  });
  (0,react.useEffect)(function () {
    if (!error && locationData.location) {
      publish('header:selectContent', null, 'zipcode');
      (0,utils_build_esm/* setLocationCookies */.Qf)(locationData.location, zipCode, structure, config);
      refresh();
      setOpen(false);
    } else if ((0,utils_build_esm/* parseLocationError */.vu)(error, locationData.location).error) {
      span == null ? void 0 : span.addEvent('mixer.location.error', {
        'log.message': "Error calculating zipcode for ".concat(zipCode, ", error message: ").concat(error),
        'log.severity': 'error'
      });
      var message = (0,utils_build_esm/* parseLocationError */.vu)(error, locationData.location).type;
      publish('header:impression', message, 'error');
    }
  }, [error, JSON.stringify(locationData.location)]);
  var handleSubmitZipCode = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(e, value) {
      var zipcodeInput;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            zipcodeInput = value == null ? void 0 : value.replace(/-/, '');
            if (!((zipcodeInput == null ? void 0 : zipcodeInput.length) === 8)) {
              _context.next = 5;
              break;
            }
            zipCodeSet(zipcodeInput);
            _context.next = 5;
            return getData({
              zipCode: zipcodeInput
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmitZipCode(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return react.createElement(react.Fragment, null, open && react.createElement(DialogStyled, {
    position: position,
    type: dialogType,
    fullScreen: true,
    onClickOutside: function onClickOutside() {
      return setOpen(false);
    },
    showClose: false,
    titleStyle: titleStyle
  }, react.createElement(GridContainer, null, image && react.createElement(ImageContainer, {
    "data-testid": "zipcode-image-container"
  }, react.createElement(BackgroundImg, {
    alt: titleText,
    src: image,
    lazy: true
  })), react.createElement(InputContainer, null, showClose && react.createElement(CloseComponent, null, react.createElement(esm/* Icon */.JO$, {
    name: "Close",
    color: "#999",
    cursor: "pointer",
    "aria-label": "Close",
    onClick: function onClick() {
      return setOpen(false);
    },
    "data-testid": "CloseIcon"
  })), titleText && react.createElement(Title, {
    "data-testid": "zipcode-title"
  }, titleText), subTitleText && react.createElement(Subtitle, {
    "data-testid": "zipcode-subtitle"
  }, subTitleText), react.createElement(ZipcodeInput/* default */.Z, (0,esm_extends/* default */.Z)({}, (0,utils_build_esm/* inputLocationText */.Ol)((0,utils_build_esm/* parseLocationError */.vu)(error, locationData.location).error), {
    loading: loading,
    onChange: handleSubmitZipCode,
    initialValue: zipcode,
    inputButtonText: inputButtonText,
    showButton: showButton
  }))))));
}
ZipCodeInput.defaultProps = {
  open: false,
  "static": {}
};
 false ? 0 : void 0;
ZipCodeInput.ssr = false;
/* harmony default export */ var ZipCodeInput_ZipCodeInput = (ZipCodeInput);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ZipCodeInput/index.js


/***/ })

}]);